import { InteractionStatus } from '@azure/msal-browser';
// import { InteractionRequiredAuthError } from '@azure/msal-common';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginRedirectRequest } from '../config/auth.config';
import { msalSigninSuccess } from '../state';

const MsalReduxIntegration = () => {
  const dispatch = useDispatch();
  const { accounts, instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    const activeAccount = instance.getActiveAccount();
    const account = activeAccount || (accounts.length === 1 ? accounts[0] : undefined);

    if (account) {
      if (!activeAccount) {
        instance.setActiveAccount(account);
      }

      dispatch(msalSigninSuccess(account.name || '', account.username));
      return;
    }

    instance.loginRedirect(loginRedirectRequest);
  }, [accounts, dispatch, inProgress, instance, isAuthenticated]);

  return null;
};

export default MsalReduxIntegration;
